(function () {
  const SMSBUMP_LOADER_URL = 'https://cdn.shopify.com/extensions/019bfb90-63a8-79f2-8054-b29095e86838/smsbump-26/assets/forms-loader.js';

  const formContainer = document.getElementById('form-container');
  if (!formContainer) {
    return;
  }

  if (!formContainer.querySelector('.pxFormGenerator')) {
    return;
  }

  formContainer.classList.add('loading');

  if (!document.querySelector('script[src*="forms-loader.js"]')) {
    const script = document.createElement('script');
    script.src = SMSBUMP_LOADER_URL;
    script.async = true;
    document.head.appendChild(script);
  }

  const checkInterval = setInterval(function () {
    const iframe = formContainer.querySelector('iframe');
    if (!iframe) {
      return;
    }
    clearInterval(checkInterval);
    iframe.addEventListener('load', function () {
      formContainer.classList.remove('loading');
    });
    setTimeout(function () {
      formContainer.classList.remove('loading');
    }, 2000);
  }, 100);

  setTimeout(function () {
    clearInterval(checkInterval);
    formContainer.classList.remove('loading');
  }, 15000);
})();
